import axiosInstance from "../../axios";

export const getDealerBuyers = () => {
  return axiosInstance.get("/store/dealer_buyers");
};

export const getDealerOrders = () => {
  return axiosInstance.get("/store/dealer_orders");
};

export const updateStoreBuyerStatus = (buyerId, status) => {
  return axiosInstance.patch(`/store_buyers/${buyerId}/update_status`, {
    status,
  });
};

export const updateStoreBuyer = (buyerId, attrs) => {
  return axiosInstance.patch(`/store_buyers/${buyerId}`, attrs);
};

export const getStoreBuyersDashboard = () => {
  return axiosInstance.get("/store_buyers/dashboard");
};

export const searchStoreBuyerUsers = (mobile) => {
  return axiosInstance.get("/store_buyers/search_buyer_users", {
    params: { mobile },
  });
};

export const getStoreAdminUsers = () => {
  return axiosInstance.get("/store_buyers/admin_users");
};

export const getStoreBuyer = (buyerId) => {
  return axiosInstance.get(`/store_buyers/${buyerId}`);
};

export const importStoreLeadBuyers = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axiosInstance.post("/store_buyers/import_leads", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const importStoreContactBuyers = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axiosInstance.post("/store_buyers/import_contacts", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getStoreBuyersOrders = () => {
  return axiosInstance.get("/store_buyers/orders");
};

export const getStoreNotifications = () => {
  return axiosInstance.get("/store_buyers/notifications");
};

export const refreshStoreBroadcastStatus = (broadcastId) => {
  return axiosInstance.post(`/store/broadcasts/${broadcastId}/refresh_status`);
};

export const getStoreBroadcasts = () => {
  return axiosInstance.get("/store/broadcasts");
};

export const getStoreBroadcast = (broadcastId) => {
  return axiosInstance.get(`/store/broadcasts/${broadcastId}`);
};

export const createStoreBroadcast = ({
  template,
  criteria,
  store_user_ids,
}) => {
  return axiosInstance.post("/store/broadcasts", {
    template,
    criteria,
    store_user_ids,
  });
};

export const CATALOG_UPDATE_CSV_FIELDS = [
  "cp",
  "cp_sizes",
  "ranges",
  "cp_features",
  "cp_packets",
  "hardwares",
  "product_rendering",
  "property_material_mapper",
  "drawer_mapper",
];

export const getStoreCatalogUpdates = () => {
  return axiosInstance.get("/store/catalog_updates");
};

export const getStoreCatalogUpdate = (catalogUpdateId) => {
  return axiosInstance.get(`/store/catalog_updates/${catalogUpdateId}`);
};

export const getStoreCatalogUpdateTaskLog = (catalogUpdateId, stage) => {
  return axiosInstance.get(`/store/catalog_updates/${catalogUpdateId}/task_log`, {
    params: { stage },
  });
};

export const createStoreCatalogUpdate = (filesByField) => {
  const formData = new FormData();
  CATALOG_UPDATE_CSV_FIELDS.forEach((field) => {
    const file = filesByField[field];
    if (file) {
      formData.append(field, file);
    }
  });
  return axiosInstance.post("/store/catalog_updates", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const updateStoreCatalogUpdateCsvs = (catalogUpdateId, filesByField) => {
  const formData = new FormData();
  CATALOG_UPDATE_CSV_FIELDS.forEach((field) => {
    const file = filesByField[field];
    if (file) {
      formData.append(field, file);
    }
  });
  return axiosInstance.patch(`/store/catalog_updates/${catalogUpdateId}/update_csvs`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const generateStoreCatalogUpdate = (catalogUpdateId, { cpCodes } = {}) => {
  const body =
    cpCodes && String(cpCodes).trim()
      ? { cp_codes: String(cpCodes).trim() }
      : {};
  return axiosInstance.post(
    `/store/catalog_updates/${catalogUpdateId}/generate`,
    body
  );
};

export const publishStoreCatalogUpdate = (catalogUpdateId, { cpCodes } = {}) => {
  const body =
    cpCodes && String(cpCodes).trim()
      ? { cp_codes: String(cpCodes).trim() }
      : {};
  return axiosInstance.post(
    `/store/catalog_updates/${catalogUpdateId}/publish`,
    body
  );
};

export const getStoreCatalogGlbInventory = () => {
  return axiosInstance.get("/store/catalog_updates/glb_inventory");
};

export const uploadStoreCatalogGlbs = (glbFiles) => {
  const formData = new FormData();
  (glbFiles || []).forEach((file) => {
    formData.append("glbs[]", file);
  });
  return axiosInstance.post("/store/catalog_updates/upload_glbs", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const renderStoreCatalogUpdateImages = (
  catalogUpdateId,
  { glbFiles, cpCodes, overwrite = false } = {}
) => {
  const files = glbFiles || [];
  const trimmedCpCodes = cpCodes && String(cpCodes).trim();

  if (files.length > 0) {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("glbs[]", file);
    });
    if (trimmedCpCodes) {
      formData.append("cp_codes", trimmedCpCodes);
    }
    if (overwrite) {
      formData.append("overwrite", "true");
    }
    return axiosInstance.post(
      `/store/catalog_updates/${catalogUpdateId}/render_images`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }

  const body = {};
  if (trimmedCpCodes) {
    body.cp_codes = trimmedCpCodes;
  }
  if (overwrite) {
    body.overwrite = true;
  }
  return axiosInstance.post(
    `/store/catalog_updates/${catalogUpdateId}/render_images`,
    body
  );
};

export const getStoreBuyerActivities = (buyerId) => {
  return axiosInstance.get(`/store_buyers/${buyerId}/activities`);
};

export const getStoreDealersDashboard = () => {
  return axiosInstance.get("/store_buyers/dealers");
};

export const assignStoreBuyerDealer = (buyerId, dealerId) => {
  return axiosInstance.patch(`/store_buyers/${buyerId}/assign_dealer`, {
    dealer_id: dealerId,
  });
};

export const patchStoreShipmentStatus = (shipmentId, status) => {
  return axiosInstance.patch(`/store/shipments/${shipmentId}`, {
    status,
  });
};

export const getStoreShipmentInvoice = (shipmentId) => {
  return axiosInstance.get(`/store/shipments/${shipmentId}/invoice`);
};

export const updateStoreProject = (projectId, params = {}) => {
  return axiosInstance.patch(`/store/projects/${projectId}`, params);
};

export const updateStoreProjectStatus = (
  projectId,
  status,
  mode = null,
  rejectionRemarks = null
) => {
  const payload = { status };

  if (mode) payload.mode = mode;
  if (rejectionRemarks) payload.rejection_remarks = rejectionRemarks;

  return axiosInstance.patch(
    `/store/projects/${projectId}/update_status`,
    payload
  );
};

export const getStoreProjectPayments = (projectId) => {
  return axiosInstance.get(`/store/projects/${projectId}/payments`);
};

export const createStoreProjectPayment = (projectId, attrs) => {
  return axiosInstance.post(`/store/projects/${projectId}/payments`, attrs);
};

export {
  getCreditNotes,
  getCreditNote,
  createAdjustment,
  getProjectAdjustments,
  hasAnyCreditNotes,
} from "../creditNotes/service";
